import { createSelector } from 'reselect';
import { selectAllCategories } from './selectAllCategories';

const findOnlyNovelties = (categories) =>
  categories.find(
    (category) => category.name === 'Новинки' && category.block === 'Спецпредложение',
  );

export const selectOnlyNoveltiesCategory = createSelector(selectAllCategories, findOnlyNovelties);
